module.exports = __webpack_public_path__ + "static/media/chart-area.3da360c0.svg";